import { type ColorKey } from '@jotta/design-system/system'

export const unbrandedColorPallette = [
  'unbranded_colors__blue',
  'unbranded_colors__green',
  'unbranded_colors__purple',
  'unbranded_colors__red',
  'unbranded_colors__yellow',
] as const satisfies ColorKey[]
